import React, { Component } from "react";
import { Button, Form, Icon, Table, Grid, Card } from "tabler-react";
import { timingSafeEqual } from "crypto";
import { Crud_Catalogos, Crud_error } from '../../../../herramientas/Crud_Catalogos';
class  Configuracion extends Component {
  constructor(props) {
    super(props);
    this.state = { 
                      id: "",
                  accion: this.props.accion, //'nuevo'// modificar, nuevo
                  plataformaCorreo:[],
                  correo: ""
                 };
    this.plataformaCorreo=[];
    this.valid={correo: false};
  }
  getfuntion = (metodo="get", obj=[], id="", catalogo="", stateVar= "", hiddenModl="") =>{
    return Crud_Catalogos(catalogo, "plataformas", metodo, id, obj,"" , stateVar, hiddenModl, []).then((returnVal) => {
        /**
         * filtro de variables
         */
        switch (metodo) {
          case "get":
            {}
            break;
          case "post":
            {
              if (stateVar === "plataformaCorreo"){ 
                if(returnVal.idCorreoConfiguracion){ //this.setCorreoPlataforma= returnVal[0]; 
                  //this.plataformaCorreo={ "idPlataforma": this.props.elementos.id, "idCorreoConfiguracion": this.configuracion };
                  this.getfuntion("post", this.plataformaCorreo, "", "correoPlataformas","plataformaCorreo")
                  this.setState({accion: "modificar"});
                  this.props.setCorreoPlataforma(this.plataformaCorreo);
                }else{ alert("error intenta de nuevo ..!") }
              }
            }
            break;
          case "put":
            {
              if (stateVar === "configuracion"){ 
                if(returnVal.idCorreoConfiguracion){ this.plataformaCorreo= returnVal; }else{ alert("error intenta de nuevo ..!") }
              }
            }
            break;
          case "delete":
            {
            }
              break;
          default:
            break;
        }
      }).catch(err =>{
        if( err.response ){
          console.log(err.response);
        }else{
          /**
           * Error
           */
          console.log("Error desconocido ....");
          console.log(err)
        }
    })
  }
  componentDidMount =() => {    
    if(this.state.accion !== 'nuevo'){
      if(this.props.getCorreoPlataforma){
        this.valid={correo: true};
        this.plataformaCorreo= this.props.getCorreoPlataforma; 
        this.setState({ plataformaCorreo: this.props.getCorreoPlataforma });

        this.setState({correo: this.plataformaCorreo.correo});
        this.setState({accion: "modificar"});
      }else{
        this.valid={correo: false};
        this.plataformaCorreo={"correo": "", "idPlataforma": this.props.elementos.id };
        this.setState({accion: "nuevo"});
      }
    }else{
      this.valid={correo: false};
      this.plataformaCorreo={"correo": "", "idPlataforma": this.props.elementos.id };
      this.setState({accion: "nuevo"});
    }
  }
  
  isValid=(campo) =>{
    switch (campo) {
      case "correo": return this.valid.correo;
        break;
      default:
        break;
    }
  }
  changeCorreo =(event) =>{
    var mail= false; var arroba= false; var domain= false;
    var mailChart= ""; var arrobaChart= ""; var domainChart= "";
    var temp= event.target.value;
    var count= 0;
    this.setState({ correo: event.target.value })

    for (var i = 0; i < temp.length; i++) {
      if( temp.charAt(i) == " "){
        this.valid.correo= false;
        break;
      }
      if(!arroba && !domain && temp.charAt(i) == "@"){ 
        arrobaChart=arrobaChart+temp.charAt(i); arroba= true;  
        if(mailChart.length > 2 ){ mail=true }
      }
      if(!arroba && !domain){ mailChart= mailChart+temp.charAt(i); }
      if(mail && arroba && temp.charAt(i) !== "@"){ domainChart= domainChart+temp.charAt(i); }
    }
    if(domainChart.includes(".") && domainChart.length > 4 && domainChart.charAt(0) !== "." && domainChart.charAt(domainChart.length-1) !== "." ){ domain= true; }
    if(mail && arroba && domain ){
      this.valid.correo= true;
    }else{ 
      this.valid.correo= false;
    }
    this.plataformaCorreo.correo= event.target.value;
  }
  render(){
    return (
      <div>
        {/**
          *   Configuracion de correo
          */
        }
          <div>
            <Grid.Row>
              <Grid.Col>
                <Card
                  title="Configuración"
                  isCollapsible={ false }
                  //isClosable
                  isCollapsed={ false}
                  //options={ }
                  body={
                  <div>
                    <Grid.Row>
                      <Grid.Col sm={12} md={6}>
                        <Form.Group label={"Los correos de la pltaforma "+ this.props.elementos.nombre+", Saldran de la siguiente cuenta de correo:"}>
                          <Form.Input
                            type="text" name="correo" feedback="Correo invalido" value={this.state.correo} placeholder="mail@xxx.xx"
                            invalid={!this.isValid("correo") && this.state.correo.length > 0} valid={this.isValid("correo") && this.state.correo.length > 0 }
                            onChange={this.changeCorreo}
                            disabled={true}
                          />
                        </Form.Group>
                      </Grid.Col>
                    </Grid.Row> 
                  </div>
                }
                />
              </Grid.Col>
            
            </Grid.Row>
          </div>
      </div>
    )
  }
}

export default Configuracion
